import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Iframe from 'react-iframe';

// @mui material components
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';
import MDInput from 'components/MDInput';
import TableHeader from 'components/Table/TableHeader';
import MDTypography from 'components/MDTypography';
import TabPanel from 'components/TabPanel/TabPanel';
import MDSelect from 'components/MDSelect';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Navbar from 'examples/Navbars/NavBar';
import Footer from 'examples/Footer';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

const initAttr = {
  id: '',
  code: '',
  branch_id: '',
  print: '',
  sticker: '',
  remark: '',
  sticker_no: '',
  enable: 'Y',
  created_at: '',
  updated_at: '',
};

const initFind = {
  search: '',
  order_by: 'tb.id',
  order_sort: 'desc',
  nopic: 'N',
  noprice: 'N',
  noactive: 'N',
  grade: 'ALL',
  page: 1,
  perPage: 12,
  pageTotal: 0,
};

function Price() {
  const mod = 'price';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [find, setFind] = useState(initFind);
  const [attr, setAttr] = useState(initAttr);
  const [record, setRecord] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalPrint, setModalPrint] = useState(false);
  const [campaign, setCampaign] = useState({});
  const [cboCampaign, setCboCampaign] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(['', '']);
  const [openSelectId, setOpenSelectId] = useState(null);

  const view = (data) => {
    setFind(data);
    setLoading(true);

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
      }
      setLoading(false);
    });
  };

  const print = (id) => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/print`, app.token, {
      id,
      lang: app.lang,
      campaign: (campaign[id] || []).filter(Boolean),
    }).then((result) => {
      setLoading(false);
      if (result.status === 'ok') {
        setAttr({ ...attr, print: result.data.print });
        setModalPrint(true);
      }
    });
  };

  const sticker = () => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/sticker`, app.token, {
      id: attr.id,
      lang: app.lang,
    }).then((result) => {
      setLoading(false);
      if (result.status === 'ok') {
        setAttr({ ...attr, print: result.data.print, sticker_no: result.data.sticker_no });
        setModalPrint(true);
      }
    });
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, period: 'ALL', page: 1 });
              }}
            >
              <MDInput
                name='searchform'
                fullWidth
                value={find.search}
                type='search'
                onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </Card>
    );
  };

  // const renderListItem = () => {
  //   return (
  //     <Grid container spacing={2}>
  //       <Grid item xs={12} sx={{ minHeight: 500 }}>
  //         <Grid container spacing={1}>
  //           {record.map((row) => (
  //             <Grid item xs={12} sm={6} md={6} lg={6} xl={6} key={row.id}>
  //               <Card className={row.enable === 'Y' ? 'bg-light' : 'bg-secondary'}>
  //                 <CardHeader
  //                   subheader={
  //                     <MDBox>
  //                       <MDTypography variant='caption' fontSize='medium'>
  //                         {row.name}
  //                       </MDTypography>
  //                     </MDBox>
  //                   }
  //                 />
  //                 <CardContent sx={{ py: 0, px: 1.5 }}>
  //                   <Grid container>
  //                     <Grid item xs={6}>
  //                       <MDTypography variant='body2'>รหัสสินค้า: {row.code}</MDTypography>
  //                     </Grid>
  //                     <Grid item xs={6}>
  //                       <MDTypography variant='body2'>ราคา: {row.final_price} บาท</MDTypography>
  //                     </Grid>
  //                     <Grid item xs={6}>
  //                       <MDTypography variant='body2'>หน่วย: {row.unit_name}</MDTypography>
  //                     </Grid>
  //                     <Grid item xs={12}>
  //                       <MDTypography variant='body2'>
  //                         ชื่อสินค้าที่แสดง: {row.display_name}
  //                       </MDTypography>
  //                     </Grid>
  //                     <Grid item xs={12}>
  //                       <MDTypography variant='body2'>
  //                         แคมเปญ:
  //                         {row.campaign === '-'
  //                           ? ' -'
  //                           : row.campaign.split('|').map((item) => (
  //                               <span key={item}>
  //                                 <br />
  //                                 {item}
  //                               </span>
  //                             ))}
  //                       </MDTypography>
  //                     </Grid>
  //                   </Grid>
  //                   <MDBox display='flex' justifyContent='end' gap={1}>
  //                     <MDButton variant='gradient' color='info' onClick={() => print(row.id)}>
  //                       <Icon>print</Icon>&nbsp;{t(`element.print`)}
  //                     </MDButton>
  //                   </MDBox>
  //                 </CardContent>
  //               </Card>
  //             </Grid>
  //           ))}
  //         </Grid>
  //       </Grid>
  //     </Grid>
  //   );
  // };

  const renderListItem = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ minHeight: 500 }}>
          <Grid container spacing={1}>
            {record.map((row) => (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} key={row.id}>
                <Card className={row.enable === 'Y' ? 'bg-light' : 'bg-secondary'}>
                  <CardHeader
                    subheader={
                      <MDBox>
                        <MDTypography variant='caption' fontSize='medium'>
                          {row.name}
                        </MDTypography>
                      </MDBox>
                    }
                  />
                  <CardContent sx={{ py: 0, px: 1.5 }}>
                    <Grid container>
                      <Grid item xs={6}>
                        <MDTypography variant='body2'>รหัสสินค้า: {row.code}</MDTypography>
                      </Grid>
                      <Grid item xs={6}>
                        <MDTypography variant='body2'>ราคา: {row.final_price} บาท</MDTypography>
                      </Grid>
                      <Grid item xs={12}>
                        <MDTypography variant='body2'>
                          ชื่อสินค้าที่แสดง: {row.display_name}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12}>
                        <MDTypography variant='body2'>
                          แคมเปญที่แสดง:
                          {/* eslint-disable react/no-array-index-key */}
                          {(campaign[row.id] || []).map((item, index) => (
                            <span key={index}>
                              <br />
                              {item}
                            </span>
                          ))}
                        </MDTypography>
                      </Grid>
                    </Grid>
                    <MDBox display='flex' justifyContent='space-between' mt={1}>
                      <MDButton
                        variant='gradient'
                        color='secondary'
                        disabled={
                          !JSON.parse(row.campaign) || JSON.parse(row.campaign).length === 0
                        }
                        onClick={() => {
                          setOpenSelectId(openSelectId === row.id ? null : row.id);
                          const oldCampaign = campaign[row.id] || [];
                          setSelectedCampaign([oldCampaign[0] || '', oldCampaign[1] || '']);
                          const campaignArr = row.campaign ? JSON.parse(row.campaign) : [];
                          setCboCampaign(campaignArr);
                        }}
                      >
                        <Icon>touch_app</Icon>&nbsp;{t('element.select')}
                      </MDButton>
                      <MDButton variant='gradient' color='info' onClick={() => print(row.id)}>
                        <Icon>print</Icon>&nbsp;{t('element.print')}
                      </MDButton>
                    </MDBox>
                    {openSelectId === row.id && (
                      <MDBox
                        mt={2}
                        p={2}
                        sx={{
                          backgroundColor: '#f8f9fa',
                          borderRadius: '10px',
                        }}
                      >
                        <Grid container spacing={2}>
                          {[0, 1].map((index) => (
                            <Grid item xs={12} key={index}>
                              <TextField
                                select
                                fullWidth
                                size='small'
                                label={`Campaign ${index + 1}`}
                                value={selectedCampaign[index]}
                                SelectProps={{
                                  renderValue: (selected) => selected || '-- เลือกแคมเปญ --',
                                }}
                                onChange={(e) => {
                                  const newValue = [...selectedCampaign];
                                  newValue[index] = e.target.value;
                                  setSelectedCampaign(newValue);
                                }}
                              >
                                <MenuItem value=''>-- เลือกแคมเปญ --</MenuItem>
                                {cboCampaign.map((item, index) => (
                                  <MenuItem
                                    key={index}
                                    value={item.value}
                                    sx={{
                                      whiteSpace: 'normal',
                                      wordBreak: 'break-word',
                                      lineHeight: 1.3,
                                    }}
                                  >
                                    {item.value} {'->'} Code: {item.code} Name: {item.name}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                          ))}
                        </Grid>
                        <MDBox display='flex' justifyContent='end' gap={1} mt={2}>
                          <MDButton
                            size='small'
                            color='secondary'
                            onClick={() => setOpenSelectId(null)}
                          >
                            {t('element.cancel')}
                          </MDButton>
                          <MDButton
                            size='small'
                            color='info'
                            onClick={() => {
                              const filtered = selectedCampaign.filter((c) => c !== '').slice(0, 2);
                              setCampaign((prev) => ({
                                ...prev,
                                [row.id]: filtered,
                              }));
                              setOpenSelectId(null);
                            }}
                          >
                            {t('element.save')}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderPrint = () => {
    return (
      <Dialog
        open={modalPrint}
        maxWidth='xl'
        keepMounted
        aria-describedby='dialog-print'
        fullScreen
        onClose={() => setModalPrint(false)}
      >
        <DialogTitle>
          #{attr.code}
          <IconButton
            aria-label='close'
            onClick={() => setModalPrint(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {attr.print === '' ? null : (
            <Iframe
              url={attr.print}
              width='100%'
              height='100%'
              id='print'
              className=''
              display='initial'
              position='relative'
              frameBorder='0'
            />
          )}
        </DialogContent>
      </Dialog>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);
  }, [id]);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.product`), t(`menu.price_tag`)]} />
      <Grid item xs={12} sm={9} md={10} lg={11} pb={1}>
        {renderSearch()}
      </Grid>
      {renderListItem()}
      {renderPrint()}
      <Footer />
    </DashboardLayout>
  );
}

export default Price;
